<template>
  <main>
    <HeaderV1 v-if="activeUser != null" />
    <div class="container-fluid main-container" v-if="activeUser != null">
      <router-view />
    </div>
    <div class="" v-else>
      <router-view />
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import HeaderV1 from "@/core/views/designlanguage/v1/HeaderV1.vue";

export default defineComponent({
  name: "LayoutV1",
  components: {
    HeaderV1
  },
  setup() {
    const store = useStore();
    const activeUser = computed(() => store.getters.oidcUser);
    return {
      activeUser
    };
  }
});
</script>

<style lang="scss">
@use "@/core/scss/styles" as *;
</style>
<style scoped>
.main-container {
  margin-top: 90px;
}
</style>
